import moment from 'moment'
import { FormattedMessage } from 'react-intl'

import MenuButton from '@/components/buttons/MenuButton'

import messages from './messages'

export default ({ intl, onEdit, onDelete }: any) => [
  {
    property: 'name',
    header: {
      label: intl.formatMessage(messages.name)
    },
    cell: {
      property: 'name',
      formatters: [
        (name: any, data: any) => {
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div className="app-item-container" onClick={() => onEdit(data.rowData)}>
              <div className="app-name">
                <p className="name-title">{name}</p>
              </div>
            </div>
          )
        }
      ],
      props: {
        className: 'app-item-table-cell'
      }
    }
  },
  {
    property: 'description',
    header: {
      label: intl.formatMessage(messages.description)
    },
    cell: {
      property: 'description',
      formatters: [
        (description: any, data: any) => {
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div onClick={() => onEdit(data.rowData)}>
              <p className="toolbar-description">{description}</p>
            </div>
          )
        }
      ]
    }
  },
  {
    property: 'createdAt',
    header: {
      label: intl.formatMessage(messages.creation)
    },
    cell: {
      property: 'createdAt',
      formatters: [
        (createdAt: any, data: any) => {
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div onClick={() => onEdit(data.rowData)}>
              <p className="toolbar-created-date">{moment(createdAt).format('MMMM D, YYYY')}</p>
            </div>
          )
        }
      ]
    }
  },
  {
    property: 'id',
    cell: {
      transforms: [
        // @ts-expect-error
        (_id, { rowData }: any) => ({
          index: rowData.id
        })
      ],
      formatters: [
        (id: any, { rowData }: any) => {
          const menuOptions = []
          menuOptions.push(
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div key="delete" className="menu-item" onClick={() => onDelete(rowData)}>
              <FormattedMessage {...messages.deleteMenuButton} />
            </div>
          )

          return (
            <div data-testid="toolbar-menu-button">
              <MenuButton className="toolbar-menu-button">{menuOptions}</MenuButton>
            </div>
          )
        }
      ]
    }
  }
]
